import { ApiRootEffects } from '@schir-int-client/api-root';

export const effects = [ApiRootEffects];
